import { type Static, Type } from "@sinclair/typebox"
import {
  type FriendRequestRecordList,
  type FriendRequestStatusSchema,
  ManagedFriendRequestRecordSchema,
  NonEmptyStringSchema,
} from "../schemas"

export type FriendRequestStatus = Static<typeof FriendRequestStatusSchema>
export type FriendRequestRecord = Static<
  typeof ManagedFriendRequestRecordSchema
>

export const FriendRequestStoreSchema = Type.Record(
  Type.String(),
  ManagedFriendRequestRecordSchema,
)

export type FriendRequestStore = Static<typeof FriendRequestStoreSchema>

export const FRIEND_REQUEST_STORE_KEY = "craft-force.friend-requests"
export const FRIEND_REQUEST_STORE_VERSION = 1
export const EMPTY_FRIEND_REQUEST_STORE: FriendRequestStore = {}

export const FriendAliasStoreSchema = Type.Record(
  Type.String(),
  NonEmptyStringSchema,
)

export type FriendAliasStore = Static<typeof FriendAliasStoreSchema>

export const FRIEND_ALIAS_STORE_KEY = "craft-force.friend-aliases"
export const FRIEND_ALIAS_STORE_VERSION = 1
export const EMPTY_FRIEND_ALIAS_STORE: FriendAliasStore = {}

export function createFriendRequestId(): string {
  return `friend_${crypto.randomUUID().replace(/-/gu, "")}`
}

export function friendRequestStoreToList(
  store: FriendRequestStore,
): FriendRequestRecordList {
  return Object.values(store)
}

export function friendRequestListToStore(
  records: readonly FriendRequestRecord[],
): FriendRequestStore {
  return Object.fromEntries(records.map((record) => [record.requestId, record]))
}
